import styled from 'styled-components';
import React, { useEffect } from 'react';
import { useIframeHeightUpdater } from '@/core/hooks/useIframeHeightUpdater';

export interface RenderWidgetProps {
	id: string;
	ownerId: number;
	containerId: string;
	params: any;
}

const AdfoxWidgetWrap = styled.div`
  iframe {
    min-height: auto;
  }

  & > div {
    height: auto !important;
  }

  & + .tooltip-rm {
    display: none;
  }
`;

const AdfoxWidget: React.FC<RenderWidgetProps> = ({ id, ownerId, containerId, params }) => {
	useIframeHeightUpdater(id);

	// Инициализация виджета через yaContextCb
	useEffect(() => {
		if (import.meta.env.PROD && window.yaContextCb) {
			window.yaContextCb.push(() => {
				// @ts-ignore
				Ya.adfoxCode.create({
					ownerId,
					containerId,
					params,
				});
			});
		}
	}, [id, ownerId, containerId, params]);

	return <AdfoxWidgetWrap id={id} />;
};

export default AdfoxWidget;
